// extracted by mini-css-extract-plugin
export var fullWidthButton = "_hh-0";